<template>
  <b-select
    icon="city-variant-outline"
    :placeholder="label"
    v-model="empresaSelecionada"
    :disabled="disabled"
    required
    expanded
  >
    <option v-for="empresa in getEmpresas" :key="empresa.id" :value="empresa">
      {{ empresa.razaoSocial }}
    </option>
  </b-select>
</template>

<script>
export default {
  name: "SelectEmpresa",
  props: {
    selected: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "Selecione uma Empresa",
    },
    contratantes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      empresas: [],
      empresaSelecionada: null,
    };
  },
  mounted() {
    if (this.contratantes.length > 0) {
      this.empresas = this.contratantes;
      this.setSelectedEmpresa();
      return;
    }

    this.$http
      .get(`/empresas?size=1000&orderBy=razaoSocial,ASC`)
      .then((response) => {
        this.empresas = response.data.content;
        this.setSelectedEmpresa();
      });
  },
  computed: {
    getEmpresas() {
      return Array.isArray(this.empresas)
        ? this.empresas.map((empresa) => ({
            razaoSocial: empresa.razaoSocial,
            id: empresa.id,
          }))
        : [];
    },
  },
  watch: {
    empresaSelecionada(newValue) {
      this.$emit("empresaSelecionada", newValue);
    },
    selected(newValue) {
      // Encontre o objeto empresa pelo id
      const empresaObj =
        this.getEmpresas.find((e) => e.id === newValue) || null;
      this.empresaSelecionada = empresaObj;
    },
  },
  methods: {
    setSelectedEmpresa() {
      if (this.selected) {
        const empresaObj =
          this.getEmpresas.find((e) => e.id === this.selected) || null;
        this.empresaSelecionada = empresaObj;
      }
    },
  },
};
</script>
